// SearchMenu.js
import React, { useState } from 'react';
import './PromotionSearchMenu.scss';
import SkeletonLoader from '../skeletonLoader/SkeletonLoader';

const PromotionSearchMenu = ({ searchedKeywords, searchInput, handleListClick, showAllList, loading }) => {
    const highlightText = (text, query) => {
        if (!query) return text;
        const parts = text.split(new RegExp(`(${query})`, 'gi'));
        return parts.map((part, index) =>
            part.toLowerCase() === query.toLowerCase()
                ? <span key={`part${index}`}>{part}</span>
                : part
        );
    };

    return (
        <div className="promotion-search-container">
            {loading ? (
                <ul className="promotion-search-list">
                    {Array.from({ length: 4 }).map((_, idx) => (
                        <li key={idx} className="list-content">
                            <SkeletonLoader className='placeholder-class' />
                        </li>
                    ))}
                </ul>
            ) : showAllList && searchedKeywords?.length > 0 && (
                <ul className="promotion-search-list">
                    {
                        searchedKeywords.map((el, index) => (
                            <li key={index} className="list-content" onClick={() => handleListClick(el, true)}>
                                {highlightText(el.keyword, searchInput)}
                            </li>
                        ))
                    }
                </ul>
            )}
        </div>
    );
};

export default PromotionSearchMenu;
